/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Storelink1Inputs */

const id_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const ms_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const da_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const de_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const en_us2_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const es_es2_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const es_mx2_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const fil_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const fr_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const it_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const hu_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const nl_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const no_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const pl_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const pt_br2_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const pt_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const ro_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const fi_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const sv_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const vi_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const tr_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const cs_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const bg_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const ru_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const uk_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const ar_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const hi_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const th_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const ja_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const zh_cn2_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏商城`)
};

const zh_hant1_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲商城`)
};

const ko_misc_posts_storelink1 = /** @type {(inputs: Misc_Posts_Storelink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

/**
* | output |
* | --- |
* | "Epic Games Store" |
*
* @param {Misc_Posts_Storelink1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_storelink1 = /** @type {((inputs?: Misc_Posts_Storelink1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Storelink1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_storelink1(inputs)
	if (locale === "ms") return ms_misc_posts_storelink1(inputs)
	if (locale === "da") return da_misc_posts_storelink1(inputs)
	if (locale === "de") return de_misc_posts_storelink1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_storelink1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_storelink1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_storelink1(inputs)
	if (locale === "fil") return fil_misc_posts_storelink1(inputs)
	if (locale === "fr") return fr_misc_posts_storelink1(inputs)
	if (locale === "it") return it_misc_posts_storelink1(inputs)
	if (locale === "hu") return hu_misc_posts_storelink1(inputs)
	if (locale === "nl") return nl_misc_posts_storelink1(inputs)
	if (locale === "no") return no_misc_posts_storelink1(inputs)
	if (locale === "pl") return pl_misc_posts_storelink1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_storelink1(inputs)
	if (locale === "pt") return pt_misc_posts_storelink1(inputs)
	if (locale === "ro") return ro_misc_posts_storelink1(inputs)
	if (locale === "fi") return fi_misc_posts_storelink1(inputs)
	if (locale === "sv") return sv_misc_posts_storelink1(inputs)
	if (locale === "vi") return vi_misc_posts_storelink1(inputs)
	if (locale === "tr") return tr_misc_posts_storelink1(inputs)
	if (locale === "cs") return cs_misc_posts_storelink1(inputs)
	if (locale === "bg") return bg_misc_posts_storelink1(inputs)
	if (locale === "ru") return ru_misc_posts_storelink1(inputs)
	if (locale === "uk") return uk_misc_posts_storelink1(inputs)
	if (locale === "ar") return ar_misc_posts_storelink1(inputs)
	if (locale === "hi") return hi_misc_posts_storelink1(inputs)
	if (locale === "th") return th_misc_posts_storelink1(inputs)
	if (locale === "ja") return ja_misc_posts_storelink1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_storelink1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_storelink1(inputs)
	return ko_misc_posts_storelink1(inputs)
});
export { misc_posts_storelink1 as "misc.posts.storeLink" }